export type Environments = 'localhost' | 'dev' | 'stg' | 'prod';

export enum AppEnvironment {
  Local = 'localhost',
  Dev = 'dev',
  UAT = 'stg',
  Production = 'prod'
}
